'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'face-thinking';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e39b';
var svgPathData = ['M32 256C32 132.3 132.3 32 256 32S480 132.3 480 256c0 107.5-75.7 197.2-176.6 219 .4-3.6 .6-7.3 .6-11 0-53-43-96-96-96l-69.5 0c-13.2-37.3-48.7-64-90.5-64-3.6 0-7.2 .2-10.7 .6-3.5-15.6-5.3-31.9-5.3-48.6zM98.1 135.9c4.4 7.7 14.2 10.3 21.8 6l13.1-7.5c21-12 47.1-11.1 67.3 2.3l30.9 20.6c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L218 110.1c-30.3-20.2-69.3-21.5-100.9-3.5l-13.1 7.5c-7.7 4.4-10.3 14.2-6 21.8zM144 336c0 8.8 7.2 16 16 16l112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0c-8.8 0-16 7.2-16 16zm8-128a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm160 16a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z', 'M303.4 475C404.3 453.2 480 363.5 480 256 480 132.3 379.7 32 256 32S32 132.3 32 256C32 272.7 33.8 288.9 37.3 304.6 26.4 305.8 16 308.9 6.5 313.4 2.2 295 0 275.7 0 256 0 114.6 114.6 0 256 0S512 114.6 512 256c0 129-95.3 235.6-219.4 253.4 5.6-10.5 9.4-22.1 10.8-34.4zM176 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm160 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM133 134.4l-13.1 7.5c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l13.1-7.5c31.6-18 70.6-16.7 100.9 3.5l30.9 20.6c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-30.9-20.6c-20.2-13.4-46.2-14.3-67.3-2.3zM144 336c0-8.8 7.2-16 16-16l112 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112 0c-8.8 0-16-7.2-16-16zM32 400l0 104c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-8c0-8.8 7.2-16 16-16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 448c-8.8 0-16-7.2-16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16zm16-48c26.5 0 48 21.5 48 48l0 16 112 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-48.4 0c-4 36-34.5 64-71.6 64l-16 0c-39.8 0-72-32.2-72-72L0 400c0-26.5 21.5-48 48-48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceThinking = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;